import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Form } from "react-bootstrap";
import { showConfirmAlert } from "../components-react/ReactAlert";
import { toast } from "react-toastify";
import {
  fetchPtTracksDataCheck,
  fetchUserDetailsByMobileData,
} from "../../redux/reducers/apiSlice";
import SelectDropdown from "../components-react/SelectDropdown";
import {
  dietPreferences,
  gender,
  memberActivityStatuses,
  memberBodyTypes,
  memberGoals,
  occupationsData,
  PT_TRIAL_INLINE_LUNGE__TEST,
  PT_TRIAL_LEG_RAISE_TEST,
  PT_TRIAL_OVERALL_FITNESS_RATING,
  PT_TRIAL_PLANK_TEST,
  PT_TRIAL_PUSHUP_TEST,
  PT_TRIAL_RUN_TEST,
  PT_TRIAL_SHOULDER_EXTENSION_TEST,
  PT_TRIAL_SHOULDER_FLEXION_TEST,
  PT_TRIAL_THOMAS_TEST,
  timeSlots,
} from "../common-data/DropdowData";
import MultiSelect from "../components-react/MultiSelect";
import { addPTTrack, uploadImage } from "../../redux/reducers/postApiSlice";
import { updatePTTrack } from "../../redux/reducers/putApiSlice";
import moment from "moment";
import {
  fetchSessionsData,
  fetchTrainerNameBySlotData,
  fetchTrainerShiftsData,
} from "../../redux/reducers/dropdownApiSlice";
import ReactVortoxSpinner from "../common-components/ReactVortoxSpinner";
import {
  convertStraight,
  convertTo24HourFormat1,
  getMaxDate,
  getMinDate,
} from "../common-data/Converts";
import { extractFileName } from "../common-data/Conversions";
import { getSelectedValue } from "./common/SharedDatas";

const PTTrialForm = ({
  trainerInfo,
  closeModal,
  decryptedText,
  callFunction,
  name,
  rowData,
  isShowBackBtn,
}) => {
  const dispatch = useDispatch();
  const { userDetailsByMobile, ptTracksDataCheck } = useSelector(
    (state) => state.api
  );
  const { trainerNamesBySlot, sessions, trainerShifts } = useSelector(
    (state) => state.dropdown
  );
  const { loading } = useSelector((state) => state.postApi);

  const isTrainer = decryptedText?.account_type === "trainer";

  const iniUserInfo = {
    mobile:
      (name === "edit" || name === "initiate-handover") && rowData?.user_mobile
        ? rowData.user_mobile
        : "",
    email:
      (name === "edit" || name === "initiate-handover") && rowData?.user_email
        ? rowData.user_email
        : "",
    name:
      (name === "edit" || name === "initiate-handover") && rowData?.user_name
        ? rowData.user_name
        : "",
    gender:
      (name === "edit" || name === "initiate-handover") && rowData?.gender
        ? { label: rowData.gender, value: rowData.gender }
        : "",
    user_id:
      (name === "edit" || name === "initiate-handover") && rowData?.user_id
        ? rowData.user_id
        : "",
    gym_id:
      (name === "edit" || name === "initiate-handover") && rowData?.gym_id
        ? rowData.gym_id
        : "",
  };
  const [userInfo, setUserInfo] = useState(iniUserInfo);
  const [isFetchUser, setIsFetchUser] = useState(false);

  const userGoalsArray =
    (name === "edit" || name === "initiate-handover") && rowData?.user_goal
      ? rowData.user_goal.split(",").map((goal) => goal.trim())
      : [];
  const matchedUserGoals = userGoalsArray.filter((goal) =>
    memberGoals.some((item) => item.value === goal)
  );
  const selectedUserGoals = matchedUserGoals.map((goal) => ({
    label: goal.replace(/_/g, " "),
    value: goal,
  }));
  const unmatchedUserGoals = userGoalsArray.filter(
    (goal) => !memberGoals.some((item) => item.value === goal)
  );
  if (unmatchedUserGoals.length > 0) {
    selectedUserGoals.push({
      label: "Other",
      value: "other",
    });
  }
  const userGoal = unmatchedUserGoals.join(", ");

  const iniFormValues = {
    trainerId: trainerInfo?.user_id,
    gymId: trainerInfo?.gym_id,
    userName: userInfo.name,
    userId: userInfo.user_id,
    userMobile: userInfo.mobile,
    userBirthYear:
      (name === "edit" || name === "initiate-handover") &&
      rowData?.user_birthdate
        ? moment(rowData.user_birthdate, "DD-MM-YYYY")
            .tz("Asia/Kolkata")
            .format("YYYY-MM-DD")
        : "",
    selectedUserGender:
      (name === "edit" || name === "initiate-handover") && rowData?.user_gender
        ? { label: rowData.user_gender, value: rowData.user_gender }
        : "",
    userHeight:
      (name === "edit" || name === "initiate-handover") && rowData?.height
        ? rowData.height
        : "",
    userWeight:
      (name === "edit" || name === "initiate-handover") && rowData?.weight
        ? Number(rowData.weight || 0).toFixed(2)
        : "",
    userTargetWeight:
      (name === "edit" || name === "initiate-handover") &&
      rowData?.target_weight
        ? Number(rowData.target_weight || 0).toFixed(2)
        : "",
    selectedUserGoals: selectedUserGoals || "",
    userGoal: userGoal || "",
    selectedUserBodyType:
      (name === "edit" || name === "initiate-handover") && rowData?.body_type
        ? {
            label: rowData.body_type?.replace(/_/g, " "),
            value: rowData.body_type,
          }
        : "",
    selectedUserActivity:
      (name === "edit" || name === "initiate-handover") && rowData?.how_active
        ? {
            label: rowData.how_active?.replace(/_/g, " "),
            value: rowData.how_active,
          }
        : "",
    userMedicalHistory:
      (name === "edit" || name === "initiate-handover") &&
      rowData?.medical_history
        ? rowData.medical_history
        : "",
    selectedUserDietPreference:
      (name === "edit" || name === "initiate-handover") &&
      rowData?.diet_preference
        ? {
            label: rowData.diet_preference?.replace(/_/g, " "),
            value: rowData.diet_preference,
          }
        : "",
    selectedProfession:
      (name === "edit" || name === "initiate-handover") && rowData?.profession
        ? {
            label: rowData.profession?.replace(/_/g, " "),
            value: rowData.profession,
          }
        : "",
    enteredProfession: "",
    heightFt: "",
    heightInches: "",
    isInformationCorrect: false,
    isActive: true,
    isCM: true,
    bcaFile: "",
    memberAssesmentFile: "",
    memberProfileFile: "",
    fitnessCOnsultationFile: "",
    fitnessCOnsultationFile1: "",
    selectedTrialCompletedBy: "",
    selectedTrainer:
      name === "edit" && rowData?.trainer_id
        ? {
            label: rowData.trainer_name,
            value: rowData.trainer_id,
          }
        : "",
    selectedSlot: "",
    isPtProspect: name === "edit" && rowData?.is_pt_prspct ? false : false,
    notPTProspectReason:
      name === "edit" && rowData?.pt_prspct_reason
        ? rowData?.pt_prspct_reason
        : "",
    propectPTValue:
      name === "edit" && rowData?.prspct_value ? rowData.prspct_value : 0,
    prospectPTExpectedCloserDate:
      name === "edit" && rowData?.expctd_closure_date
        ? rowData.expctd_closure_date
        : "",
    selProspectSession:
      name === "edit" && rowData?.prspct_session && rowData?.prspct_duration
        ? {
            label: `${rowData.prspct_session} Sessions For ${rowData.prspct_duration} Days`,
            value: `${rowData.prspct_session}_sessions_for_${rowData.prspct_duration}_days`,
            info: {
              n_session: rowData.prspct_session,
              duration: rowData.prspct_duration,
            },
          }
        : "",
    prospectSession: 0,
    prospectDuration: 0,
    trialStartDate: "",
    selectedTrialSlot: "",

    selectedRunTest: getSelectedValue(
      PT_TRIAL_RUN_TEST,
      "min_run_test",
      rowData,
      name
    ),
    selectedPushupTest: getSelectedValue(
      PT_TRIAL_PUSHUP_TEST,
      "push_up_test",
      rowData,
      name
    ),
    selectedPlankTest: getSelectedValue(
      PT_TRIAL_PLANK_TEST,
      "plank_test",
      rowData,
      name
    ),
    selectedWallTest: getSelectedValue(
      PT_TRIAL_PLANK_TEST,
      "wall_sit_test",
      rowData,
      name
    ),
    selectedInlineLungeTest: getSelectedValue(
      PT_TRIAL_INLINE_LUNGE__TEST,
      "lunge_test",
      rowData,
      name
    ),
    selectedShoulderFlexionTest: getSelectedValue(
      PT_TRIAL_SHOULDER_FLEXION_TEST,
      "shoulder_flex_test",
      rowData,
      name
    ),
    selectedShoulderExtensionTest: getSelectedValue(
      PT_TRIAL_SHOULDER_EXTENSION_TEST,
      "shoulder_extn_test",
      rowData,
      name
    ),
    selectedLegRaiseAngleTest: getSelectedValue(
      PT_TRIAL_LEG_RAISE_TEST,
      "leg_raise_angle",
      rowData,
      name
    ),
    selectedThomasTest: getSelectedValue(
      PT_TRIAL_THOMAS_TEST,
      "thomas_test",
      rowData,
      name
    ),
    selectedOverallFitnessRating: getSelectedValue(
      PT_TRIAL_OVERALL_FITNESS_RATING,
      "overall_fitness",
      rowData,
      name
    ),
  };
  const [formValues, setFormValues] = useState(iniFormValues);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);
  const [checkPT, setCheckPT] = useState(false);

  const onClickFetchUserDetails = () => {
    const handleConfirm = () => {
      if (userInfo.mobile && userInfo.mobile?.length === 10) {
        dispatch(
          fetchUserDetailsByMobileData({
            userMobile: userInfo.mobile,
            token: decryptedText?.token,
          })
        );
        setIsFetchUser(true);
      } else {
        toast.error("Please Enter Mobile Number! (Number Must Be 10 Digit)");
      }
    };

    showConfirmAlert(
      handleConfirm,
      `Is the entered ${userInfo.mobile} number correct?`
    );
  };

  const onChangeInput = (e) => {
    setIsSubmit(false);

    const { name, value, type, checked } = e.target;
    const file = type === "file" ? e.target.files[0] : null;

    if (
      name === "memberProfileFile" ||
      name === "memberAssesmentFile" ||
      name === "fitnessCOnsultationFile" ||
      name === "fitnessCOnsultationFile1" ||
      name === "bcaFile"
    ) {
      handleUploadImage(file, name);
    } else {
      setFormValues((prev) => ({
        ...prev,
        [name]: type === "checkbox" ? checked : type === "file" ? file : value,
      }));
    }
  };

  const onChangeDropdown = (name, value) => {
    if (name === "selectedSlot") {
      setFormValues((prev) => ({
        ...prev,
        [name]: value,
        selectedTrialCompletedBy: "",
      }));
    } else {
      setFormValues((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleBack = () => {
    setFormValues(iniFormValues);
    setFormErrors({});
    setUserInfo(iniUserInfo);
    setIsFetchUser(false);
    setCheckPT(false);
  };

  const validateForm = (formValues) => {
    let errors = {};

    const selectedDate = new Date(formValues.trialStartDate);
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const isDifferentTrainer =
      formValues.selectedTrialCompletedBy?.value &&
      formValues.selectedSlot?.value;

    if (!formValues.userBirthYear) {
      errors.userBirthYear = "Member Birth Year Is Required!";
    }

    if (!formValues.selectedUserGender) {
      errors.selectedUserGender = "Member Gender Is Required!";
    }

    if (!formValues.selectedUserDietPreference) {
      errors.selectedUserDietPreference = "Member Diet Preference Is Required!";
    }

    if (!formValues.userHeight) {
      errors.userHeight = "Member Height Is Required!";
    } else if (!formValues.isCM && formValues.heightFt > 11) {
      errors.userHeight = "Member Height Must Be Valid Number!";
    }

    if (!formValues.userWeight) {
      errors.userWeight = "Member Weight Is Required!";
    }

    if (!formValues.userTargetWeight) {
      errors.userTargetWeight = "Member Target Weight Is Required!";
    }

    if (formValues.selectedUserGoals?.length === 0) {
      errors.selectedUserGoals = "Member Goal Is Required!";
    }

    if (
      formValues.selectedUserGoals?.length === 1 &&
      formValues.selectedUserGoals?.some((goal) => goal.value === "other") &&
      !formValues.userGoal
    ) {
      errors.userGoal = "Member Other Goal Is Required!";
    }

    if (!formValues.selectedUserBodyType) {
      errors.selectedUserBodyType = "Member Body Type Is Required!";
    }

    if (!formValues.selectedUserActivity) {
      errors.selectedUserActivity = "Member Activity Status Is Required!";
    }

    if (!formValues.trialStartDate) {
      errors.trialStartDate = "Trail Start Date Is Required!";
    } else if (selectedDate < today) {
      errors.trialStartDate = "Trial Start Date cannot be in the past!";
    }

    if (!isDifferentTrainer && !formValues.selectedTrialSlot) {
      errors.selectedTrialSlot = "Trail Slot Is Required!";
    }

    if (!formValues.isInformationCorrect) {
      errors.isInformationCorrect = "All The Information Must Be Correct!";
    }

    if (
      !(
        (name === "edit" || name === "initiate-handover") &&
        rowData?.bca_report
      ) &&
      !formValues.bcaFile
    ) {
      errors.bcaFile = "BCA Report Is Required!";
    }

    // if (
    //   !(
    //     (name === "edit" || name === "initiate-handover") &&
    //     rowData?.assessment_doc
    //   ) &&
    //   !formValues.memberAssesmentFile
    // ) {
    //   errors.memberAssesmentFile = "Required!";
    // }

    // if (
    //   !(
    //     (name === "edit" || name === "initiate-handover") &&
    //     rowData?.profile_doc
    //   ) &&
    //   !formValues.memberProfileFile
    // ) {
    //   errors.memberProfileFile = "Required!";
    // }

    // if (
    //   !(
    //     (name === "edit" || name === "initiate-handover") &&
    //     rowData?.ftns_cnsltnt_doc1
    //   ) &&
    //   !formValues.fitnessCOnsultationFile
    // ) {
    //   errors.fitnessCOnsultationFile = "Required!";
    // }

    // if (
    //   !(
    //     (name === "edit" || name === "initiate-handover") &&
    //     rowData?.ftns_cnsltnt_doc2
    //   ) &&
    //   !formValues.fitnessCOnsultationFile1
    // ) {
    //   errors.fitnessCOnsultationFile = "Required!";
    // }

    if (!formValues.selectedProfession) {
      errors.selectedProfession = "Member Profession Is Required!";
    } else if (
      formValues.selectedProfession &&
      formValues.selectedProfession?.value === "other" &&
      !formValues.enteredProfession
    ) {
      errors.enteredProfession = "Other Member Profession Is Required!";
    }

    // if (formValues.isPtProspect && !formValues.notPTProspectReason) {
    //   errors.notPTProspectReason = "Required!";
    // } else if (
    //   formValues.isPtProspect &&
    //   formValues.notPTProspectReason &&
    //   formValues.notPTProspectReason?.length < 20
    // ) {
    //   errors.notPTProspectReason = "Required!";
    // }

    // if (!formValues.isPtProspect && !formValues.propectPTValue) {
    //   errors.propectPTValue = "minimum PT prospect amount has to be ₹4000!";
    // } else if (
    //   !formValues.isPtProspect &&
    //   formValues.propectPTValue &&
    //   formValues.propectPTValue < 4000
    // ) {
    //   errors.propectPTValue = "minimum PT prospect amount has to be ₹4000!";
    // }

    // if (!formValues.isPtProspect && !formValues.prospectPTExpectedCloserDate) {
    //   errors.prospectPTExpectedCloserDate = "Required!";
    // }

    // if (!formValues.isPtProspect && !formValues.selProspectSession) {
    //   errors.selProspectSession = "Required!";
    // }

    // if (
    //   formValues.selProspectSession &&
    //   formValues.selProspectSession?.value === "other" &&
    //   !formValues.prospectSession
    // ) {
    //   errors.prospectSession = "Required!";
    // }

    // if (
    //   formValues.selProspectSession &&
    //   formValues.selProspectSession?.value === "other" &&
    //   !formValues.prospectDuration
    // ) {
    //   errors.prospectDuration = "Required!";
    // }

    return errors;
  };

  const handleAdd = async (requestBody, TOKEN) => {
    setIsSubmit(false);

    try {
      const actionResult =
        name === "edit"
          ? dispatch(updatePTTrack({ requestBody, filters: "", TOKEN }))
          : dispatch(addPTTrack({ requestBody, TOKEN }));
      const result = await actionResult;

      if (result?.payload?.status) {
        toast.success(result?.payload?.message || "Success!");
        setFormValues(iniFormValues);
        setFormErrors({});
        closeModal();
        callFunction();
      } else {
        const errorMessage = result?.error?.message || result?.payload?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.log("handleAdd ERROR => ", error);
    }
  };

  const onSubmit = () => {
    setFormErrors(validateForm(formValues));
    setIsSubmit(true);
  };

  function getTrainersBySlot(filter) {
    dispatch(
      fetchTrainerNameBySlotData({
        filters: filter,
        token: decryptedText?.token,
      })
    );
  }

  function getSessions(filter) {
    dispatch(
      fetchSessionsData({
        filters: filter,
        token: decryptedText?.token,
      })
    );
  }

  function geTrainerShift(filter) {
    dispatch(
      fetchTrainerShiftsData({
        filters: filter,
        token: decryptedText?.token,
      })
    );
  }

  const handleUploadImage = async (file, fileName) => {
    setIsSubmit(false);
    try {
      const actionResult = dispatch(
        uploadImage({ file, TOKEN: decryptedText?.token })
      );
      const result = await actionResult;

      if (result?.payload?.status) {
        if (fileName) {
          setFormValues((prev) => ({
            ...prev,
            [fileName]: result?.payload?.image_url || "",
          }));
        }
        toast.success("Image Upload Success!");
      } else {
        const errorMessage = result?.error?.message || result?.payload?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.log("handleUploadImage ERROR => ", error);
    }
  };

  useEffect(() => {
    if (!formValues.isPtProspect) {
      const sessionFilter = {
        gym_id: formValues.gymId || userInfo.gym_id,
      };

      getSessions(sessionFilter);
    }
  }, [formValues.isPtProspect]);

  useEffect(() => {
    if (
      isFetchUser &&
      userDetailsByMobile?.status &&
      userDetailsByMobile?.data?.length > 0
    ) {
      setIsFetchUser(false);

      const { uid, name, email, gym_id } = userDetailsByMobile?.data?.[0];

      dispatch(
        fetchPtTracksDataCheck({
          pageNo: 1,
          limit: 10,
          queryParameters: `&user_id=${uid}&trial_status=completed`,
          token: decryptedText?.token,
        })
      );

      if (trainerInfo?.gym_id === gym_id) {
        setUserInfo((prevs) => ({
          ...prevs,
          email: email,
          name: name,
          user_id: uid,
        }));
      } else {
        toast.error("Oops🙊! User Is Belong To Different Gym!");
      }
    } else if (isFetchUser && userDetailsByMobile?.status === false) {
      toast.error(userDetailsByMobile?.message);
      return;
    }
  }, [userDetailsByMobile]);

  useEffect(() => {
    if (trainerInfo?.user_id) {
      const filters = {
        trainer_id: trainerInfo.user_id || "",
      };

      geTrainerShift(filters);
    }
  }, []);

  useEffect(() => {
    if (Object.keys(userInfo)?.length > 0) {
      setFormValues((prevs) => ({
        ...prevs,
        trainerId: trainerInfo?.user_id,
        gymId: trainerInfo?.gym_id,
        userName: userInfo.name,
        userId: userInfo.user_id,
        userMobile: userInfo.mobile,
      }));
    }
  }, [userInfo]);

  useEffect(() => {
    if (
      userInfo.user_id &&
      ptTracksDataCheck?.status &&
      ptTracksDataCheck?.data?.length > 0
    ) {
      const { handover_status, trial_status } = ptTracksDataCheck?.data?.[0];

      if (handover_status !== "handover_completed") {
        toast.error("Oops🙊! User Handover Is Not Done Yet!");
        setCheckPT(false);
      } else if (trial_status === "completed") {
        toast.error("Member already taken PT trial!");
        setCheckPT(false);
      } else {
        setCheckPT(true);
      }
    } else if (userInfo.user_id) {
      setCheckPT(true);
    }
  }, [ptTracksDataCheck]);

  useEffect(() => {
    if ((name === "edit" || name === "initiate-handover") && rowData?.height) {
      const heightParts = rowData.height.split("_");
      setFormValues((prevFormValues) => ({
        ...prevFormValues,
        userHeight: heightParts[0],
        isCM: heightParts[1] === "cm",
      }));
    }

    if ((name === "edit" || name === "initiate-handover") && rowData?.weight) {
      const weightParts = rowData.weight.split("_");
      setFormValues((prevFormValues) => ({
        ...prevFormValues,
        userWeight: Number(weightParts[0] || 0).toFixed(2),
      }));
    }

    if (
      (name === "edit" || name === "initiate-handover") &&
      rowData?.target_weight
    ) {
      const weightParts = rowData.target_weight.split("_");
      setFormValues((prevFormValues) => ({
        ...prevFormValues,
        userTargetWeight: Number(weightParts[0] || 0).toFixed(2),
      }));
    }
  }, []);

  useEffect(() => {
    if (!formValues.isCM && formValues.heightFt) {
      const heightFtInCm = formValues.heightFt * 30.48; // 1 foot = 30.48 cm
      const heightInchesInCm = formValues.heightInches * 2.54; // 1 inch = 2.54 cm
      const totalHeightInCm = (heightFtInCm + heightInchesInCm).toFixed(2);

      setFormValues((prevs) => ({ ...prevs, userHeight: totalHeightInCm }));
    }
  }, [formValues.isCM, formValues.heightFt, formValues.heightInches]);

  useEffect(() => {
    if (formValues.selectedSlot?.value) {
      const [start, end] = formValues.selectedSlot.value.split("-");

      const filters = {
        gym_id:
          userInfo?.gym_id || formValues.gymId || decryptedText?.gym_id
            ? userInfo?.gym_id || formValues.gymId || decryptedText?.gym_id
            : rowData?.gym_id
            ? rowData.gym_id
            : "",
        slot_start_time: start,
        slot_end_time: end,
      };
      getTrainersBySlot(filters);
    }
  }, [formValues.selectedSlot, formValues.gymId]);

  useEffect(() => {
    if (isSubmit && Object.keys(formErrors)?.length === 0) {
      const selectedUserGoalsValues = formValues.selectedUserGoals?.map(
        (goal) => goal.value !== "other" && goal.value
      );
      if (formValues.userGoal) {
        selectedUserGoalsValues.push(formValues.userGoal);
      }
      const selectedUserGoalsString = selectedUserGoalsValues.join(", ");
      const [start, end] = formValues.selectedTrialSlot?.label?.split("TO");

      console.log(start, " <=> ", end);

      const isDifferentTrainer =
        formValues.selectedTrialCompletedBy?.value &&
        formValues.selectedSlot?.value;
      const [slotStart, slotEnd] = isDifferentTrainer
        ? formValues.selectedSlot?.value?.split("-")
        : "";

      const threeday_slot_start = convertTo24HourFormat1(
        isDifferentTrainer && slotStart ? slotStart : start || ""
      );

      const threeday_slot_end = convertTo24HourFormat1(
        isDifferentTrainer && slotEnd ? slotEnd : end || ""
      );

      const userData = {
        user_id: formValues.userId || "",
        assigned_to: formValues.selectedTrialCompletedBy?.value
          ? formValues.selectedTrialCompletedBy.value
          : formValues.trainerId || "",
        gym_id: formValues.gymId || userInfo.gym_id || "",
        user_birthdate: formValues.userBirthYear,
        user_goal: selectedUserGoalsString || "",
        diet_preference: formValues.selectedUserDietPreference?.value || "",
        gender: formValues.selectedUserGender?.value || "",
        height: (formValues.userHeight || "") + "_cm",
        weight: (formValues.userWeight || "") + "_kg",
        target_weight: (formValues.userTargetWeight || "") + "_kg",
        body_type: formValues.selectedUserBodyType?.value || "",
        how_active: formValues.selectedUserActivity?.value || "",
        medical_history: formValues.userMedicalHistory
          ? formValues.userMedicalHistory
          : "none",
        profession:
          formValues.selectedProfession?.value === "other"
            ? formValues.enteredProfession
            : formValues.selectedProfession?.value || "",
        status: formValues?.isActive ? "active" : "inactive",
        isTrialCompletedBySelf: false,
        // is_pt_prspct: formValues.isPtProspect ? 0 : 1,
        is_pt_prspct: 0,
        pt_prspct_reason: formValues.isPtProspect
          ? formValues.notPTProspectReason
          : "",
        prspct_value: !formValues.isPtProspect ? formValues.propectPTValue : "",
        expctd_closure_date: !formValues.isPtProspect
          ? formValues.prospectPTExpectedCloserDate
          : "",
        prspct_session:
          !formValues.isPtProspect &&
          formValues.selProspectSession?.value === "other"
            ? formValues.prospectSession
            : !formValues.isPtProspect
            ? formValues.selProspectSession?.info?.n_session || 0
            : "",
        prspct_duration:
          !formValues.isPtProspect &&
          formValues.selProspectSession?.value === "other"
            ? formValues.prospectDuration
            : !formValues.isPtProspect
            ? formValues.selProspectSession?.info?.duration || 0
            : "",
        threeday_start_date: formValues.trialStartDate || "",
        threeday_slot_start: threeday_slot_start,
        threeday_slot_end: threeday_slot_end,

        min_run_test: formValues.selectedRunTest?.value || "",
        push_up_test: formValues.selectedPushupTest?.value || "",
        plank_test: formValues.selectedPlankTest?.value || "",
        wall_sit_test: formValues.selectedWallTest?.value || "",
        lunge_test: formValues.selectedInlineLungeTest?.value || "",
        shoulder_flex_test: formValues.selectedShoulderFlexionTest?.value || "",
        shoulder_extn_test:
          formValues.selectedShoulderExtensionTest?.value || "",
        leg_raise_angle: formValues.selectedLegRaiseAngleTest?.value || "",
        thomas_test: formValues.selectedThomasTest?.value || "",
        overall_fitness: formValues.selectedOverallFitnessRating?.value || "",
      };

      const formData = new FormData();

      for (const key in userData) {
        if (userData.hasOwnProperty(key)) {
          formData.append(key, userData[key]);
        }
      }

      formData.append("bca_report", formValues.bcaFile || "");
      formData.append("assessment_doc", formValues.bcaFile || "");
      formData.append("profile_doc", formValues.bcaFile || "");
      formData.append("ftns_cnsltnt_doc1", formValues.bcaFile || "");
      formData.append("ftns_cnsltnt_doc2", formValues.bcaFile || "");
      // formData.append("assessment_doc", formValues.memberAssesmentFile || "");
      // formData.append("profile_doc", formValues.memberProfileFile || "");
      // formData.append(
      //   "ftns_cnsltnt_doc1",
      //   formValues.fitnessCOnsultationFile || ""
      // );
      // formData.append(
      //   "ftns_cnsltnt_doc2",
      //   formValues.fitnessCOnsultationFile1 || ""
      // );

      if (name === "edit" && rowData?.uid) {
        formData.append("uid", rowData.uid);
      }

      const handleConfirm = async () => {
        handleAdd(formData, decryptedText?.token);
      };

      showConfirmAlert(
        handleConfirm,
        `A 3-day trial for the selected member will be assigned. The trial will start on ${
          convertStraight(formValues.trialStartDate) || "-"
        } at ${
          isDifferentTrainer && slotStart && slotEnd
            ? formValues.selectedSlot?.label || ""
            : formValues.selectedTrialSlot?.label || "-"
        }. Before proceeding, please ensure all the information is accurate..`,
        "No, Cancel",
        "Yes, proceed"
      );
    }
  }, [isSubmit, formErrors]);

  return (
    <div
      className="form-container"
      // className="paymentLinkForm ptTrackFormContainer"
    >
      <form className="formContainer">
        {/* DISABLED TRAINER INFO */}
        <>
          {/* <div className="formInputsGrid fourGridSystem">
            <div className="formInputBox">
              <label htmlFor="name" className="formInputLabel">
                Name (Assigned To)
              </label>

              <input
                type="text"
                className="formInput"
                name="name"
                placeholder={`🚫 ${trainerInfo?.name || "NA"}`}
                disabled
              />
            </div>
            <div className="formInputBox">
              <label htmlFor="mobile" className="formInputLabel">
                Mobile Number (Assigned To)
              </label>

              <input
                type="number"
                className="formInput"
                name="mobile"
                placeholder={`🚫 ${trainerInfo?.mobile || "NA"}`}
                disabled
              />
            </div>
            <div className="formInputBox">
              <label htmlFor="gym_name" className="formInputLabel">
                Gym Name (Assigned To)
              </label>

              <input
                type="gym"
                className="formInput"
                name="gym_name"
                placeholder={`🚫 ${trainerInfo?.gym_name || "NA"}`}
                disabled
              />
            </div>
          </div> */}
        </>
        {/* ------------ DISABLED TRAINER INFO ------------ */}

        {/* <div className="grayLine"></div> */}

        <div className="formInputsGrid userDetails fourGridSystem">
          {name !== "edit" && (
            <div className="formInputBox">
              <label htmlFor="mobile" className="formInputLabel">
                member Number <span className="required">*</span>
              </label>

              <div
                className={`commonInputWrapper twoInput ${
                  userInfo.user_id ? "long" : "short"
                }`}>
                <input
                  type="number"
                  className="formInput"
                  name="mobile"
                  placeholder="Enter User Number"
                  value={userInfo.mobile}
                  onChange={(e) =>
                    setUserInfo((prevs) => ({
                      ...prevs,
                      mobile: e.target.value,
                    }))
                  }
                />
                {(!userInfo.user_id || !checkPT) && (
                  <button
                    type="button"
                    className="searchBtn"
                    onClick={onClickFetchUserDetails}>
                    Fetch User Details
                  </button>
                )}
              </div>
            </div>
          )}

          {checkPT && userInfo.user_id && (
            <>
              <div className="formInputBox">
                <label htmlFor="mobile" className="formInputLabel">
                  member Mobile
                </label>

                <input
                  type="number"
                  className="formInput"
                  name="mobile"
                  placeholder={`🚫 ${userInfo?.mobile || "NA"}`}
                  disabled
                />
              </div>
              <div className="formInputBox">
                <label htmlFor="name" className="formInputLabel">
                  member Name
                </label>

                <input
                  type="text"
                  className="formInput"
                  name="name"
                  placeholder={`🚫 ${userInfo?.name || "NA"}`}
                  disabled
                />
              </div>
              <div className="formInputBox">
                <label htmlFor="userBirthYear" className="formInputLabel">
                  Member Birth Year <span className="required">*</span>
                </label>

                <input
                  type="date"
                  className={`formInput ${
                    formValues.userBirthYear ? "date-has-value" : ""
                  } ${formErrors.userBirthYear ? "formError" : ""}`}
                  name="userBirthYear"
                  value={formValues.userBirthYear}
                  onChange={onChangeInput}
                  max={getMaxDate()}
                />
              </div>
              <div className="formInputBox">
                <label htmlFor="selectedUserGender" className="formInputLabel">
                  Member Gender <span className="required">*</span>
                </label>

                <div
                  className={`commonWrapper ${
                    formErrors.selectedUserGender && "formError"
                  }`}>
                  <SelectDropdown
                    options={gender.slice(0, -1)}
                    selectedOption={formValues.selectedUserGender}
                    setSelectedOption={(selectedValue) =>
                      onChangeDropdown("selectedUserGender", selectedValue)
                    }
                    name="Gender"
                    preventKeyboardOpen={true}
                  />
                </div>
              </div>
              <div className="formInputBox">
                <label
                  htmlFor="selectedUserDietPreference"
                  className="formInputLabel">
                  Member Diet Prefernce <span className="required">*</span>
                </label>

                <div
                  className={`commonWrapper ${
                    formErrors.selectedUserDietPreference && "formError"
                  }`}>
                  <SelectDropdown
                    options={dietPreferences}
                    selectedOption={formValues.selectedUserDietPreference}
                    setSelectedOption={(selectedValue) =>
                      onChangeDropdown(
                        "selectedUserDietPreference",
                        selectedValue
                      )
                    }
                    name="Diet Prefernce"
                    preventKeyboardOpen={true}
                  />
                </div>
              </div>
              <div className="formInputBox twoInputs">
                <label htmlFor="userHeight" className="formInputLabel">
                  Member Height <span className="required">*</span>
                </label>

                <div className="commonInputWrapper twoInput">
                  {!formValues.isCM ? (
                    <div className="wrappedSmallTwoInput">
                      <input
                        type="number"
                        className={`formInput ${
                          formErrors?.userHeight ? "formError" : ""
                        }`}
                        name="heightFt"
                        placeholder="Feet"
                        value={formValues.heightFt}
                        onChange={onChangeInput}
                      />
                      <input
                        type="number"
                        className={`formInput ${
                          formErrors?.userHeight ? "formError" : ""
                        }`}
                        name="heightInches"
                        placeholder="Inch"
                        value={formValues.heightInches}
                        onChange={onChangeInput}
                      />
                    </div>
                  ) : (
                    <input
                      type="number"
                      className={`formInput ${
                        formErrors?.userHeight ? "formError" : ""
                      }`}
                      name="userHeight"
                      placeholder="Enter Height"
                      value={formValues.userHeight}
                      onChange={onChangeInput}
                    />
                  )}
                  <Form.Check
                    type="switch"
                    name="isCM"
                    className={`${formErrors?.isCM ? "formError" : ""}`}
                    label={`${formValues.isCM ? "CM" : "FT/IN"}`}
                    checked={formValues.isCM}
                    onChange={onChangeInput}
                  />
                </div>
              </div>
              <div className="formInputBox twoInputs">
                <label htmlFor="userWeight" className="formInputLabel">
                  Member Current Weight <span className="required">*</span>
                </label>

                <div className="commonInputWrapper twoInput">
                  <input
                    type="number"
                    className={`formInput ${
                      formErrors?.userWeight ? "formError" : ""
                    }`}
                    name="userWeight"
                    placeholder="Enter Weight"
                    value={formValues.userWeight}
                    onChange={onChangeInput}
                  />

                  <input
                    type="text"
                    className="formInput smallInput"
                    name="name"
                    placeholder={`🚫 KG`}
                    disabled
                  />
                </div>
              </div>
              <div className="formInputBox twoInputs">
                <label htmlFor="userTargetWeight" className="formInputLabel">
                  Member Target Weight <span className="required">*</span>
                </label>

                <div className="commonInputWrapper twoInput">
                  <input
                    type="number"
                    className={`formInput ${
                      formErrors?.userTargetWeight ? "formError" : ""
                    }`}
                    name="userTargetWeight"
                    placeholder="Enter Target Weight"
                    value={formValues.userTargetWeight}
                    onChange={onChangeInput}
                  />

                  <input
                    type="text"
                    className="formInput smallInput"
                    name="name"
                    placeholder={`🚫 KG`}
                    disabled
                  />
                </div>
              </div>
              <div className="formInputBox">
                <label htmlFor="selectedUserGoals" className="formInputLabel">
                  Member Goal <span className="required">*</span>
                </label>

                <div
                  className={`commonWrapper no-border ${
                    formErrors.selectedUserGoals ? "formError" : ""
                  }`}>
                  <MultiSelect
                    options={memberGoals}
                    state={formValues.selectedUserGoals}
                    setState={(selectedValue) =>
                      setFormValues((prevs) => ({
                        ...prevs,
                        selectedUserGoals: selectedValue,
                      }))
                    }
                    name="selectedUserGoals"
                    preventKeyboardOpen={true}
                  />
                </div>
              </div>
              {formValues.selectedUserGoals?.length > 0 &&
                formValues.selectedUserGoals?.some(
                  (goal) => goal.value === "other"
                ) && (
                  <div className="formInputBox twoInputs">
                    <label htmlFor="userGoal" className="formInputLabel">
                      Member Goal (Other) <span className="required">*</span>
                    </label>
                    <input
                      type="text"
                      className={`formInput ${
                        formErrors?.userGoal ? "formError" : ""
                      }`}
                      name="userGoal"
                      placeholder="Enter Member Goal"
                      value={formValues.userGoal}
                      onChange={onChangeInput}
                    />
                  </div>
                )}
              <div className="formInputBox">
                <label
                  htmlFor="selectedUserBodyType"
                  className="formInputLabel">
                  Member Body Type <span className="required">*</span>
                </label>

                <div
                  className={`commonWrapper ${
                    formErrors.selectedUserBodyType && "formError"
                  }`}>
                  <SelectDropdown
                    options={memberBodyTypes}
                    selectedOption={formValues.selectedUserBodyType}
                    setSelectedOption={(selectedValue) =>
                      onChangeDropdown("selectedUserBodyType", selectedValue)
                    }
                    name="Body Type"
                    preventKeyboardOpen={true}
                  />
                </div>
              </div>
              <div className="formInputBox">
                <label
                  htmlFor="selectedUserActivity"
                  className="formInputLabel">
                  How Active Member Is ? <span className="required">*</span>
                </label>

                <div
                  className={`commonWrapper ${
                    formErrors.selectedUserActivity && "formError"
                  }`}>
                  <SelectDropdown
                    options={memberActivityStatuses}
                    selectedOption={formValues.selectedUserActivity}
                    setSelectedOption={(selectedValue) =>
                      onChangeDropdown("selectedUserActivity", selectedValue)
                    }
                    name="Activity"
                    preventKeyboardOpen={true}
                  />
                </div>
              </div>
              <div className="formInputBox">
                <label htmlFor="selectedProfession" className="formInputLabel">
                  Member Profession <span className="required">*</span>
                </label>

                <div
                  className={`commonWrapper ${
                    formErrors.selectedProfession && "formError"
                  }`}>
                  <SelectDropdown
                    options={occupationsData}
                    selectedOption={formValues.selectedProfession}
                    setSelectedOption={(selectedValue) =>
                      onChangeDropdown("selectedProfession", selectedValue)
                    }
                    name="Profession"
                  />
                </div>
              </div>

              <>
                {/* {name === "edit" && (
                <div className="formInputBox">
                  <label htmlFor="selectedTrainer" className="formInputLabel">
                    Trainer Name
                  </label>

                  <div
                    className={`commonWrapper ${
                      formErrors.selectedTrainer && "formError"
                    }`}
                  >
                    <SelectDropdown
                      options={trainersData}
                      selectedOption={formValues.selectedTrainer}
                      setSelectedOption={(selectedValue) =>
                        onChangeDropdown("selectedTrainer", selectedValue)
                      }
                      name="Trainer"
                    />
                  </div>
                </div>
              )} */}
              </>

              {formValues.selectedProfession?.value === "other" && (
                <div className="formInputBox twoInputs">
                  <label htmlFor="enteredProfession" className="formInputLabel">
                    Member Profession (Other){" "}
                    <span className="required">*</span>
                  </label>
                  <input
                    type="text"
                    className={`formInput ${
                      formErrors?.enteredProfession ? "formError" : ""
                    }`}
                    name="enteredProfession"
                    placeholder="Enter Profession"
                    value={formValues.enteredProfession}
                    onChange={onChangeInput}
                  />
                </div>
              )}

              <div className="formInputBox">
                <label htmlFor="trialStartDate" className="formInputLabel">
                  3 Day trial start date <span className="required">*</span>
                </label>

                <input
                  type="date"
                  className={`formInput ${
                    formValues.trialStartDate ? "date-has-value" : ""
                  } ${formErrors.trialStartDate ? "formError" : ""}`}
                  name="trialStartDate"
                  value={formValues.trialStartDate}
                  onChange={onChangeInput}
                  min={getMinDate()}
                />
              </div>

              <div className="formInputBox">
                <label htmlFor="selectedTrialSlot" className="formInputLabel">
                  select slot for 3 day trial{" "}
                  <span className="required">*</span>
                </label>

                <div
                  className={`commonWrapper ${
                    formErrors.selectedTrialSlot && "formError"
                  }`}>
                  <SelectDropdown
                    options={trainerShifts}
                    selectedOption={formValues.selectedTrialSlot}
                    setSelectedOption={(selectedValue) =>
                      onChangeDropdown("selectedTrialSlot", selectedValue)
                    }
                    name="Trial Slot"
                  />
                </div>

                {formValues.trialStartDate && trainerShifts?.length === 0 ? (
                  <span className="info">
                    {`No Slot Availble For The Trainer ${
                      trainerInfo.name || ""
                    }`}
                  </span>
                ) : null}
              </div>

              <>
                {/* {formValues.isPtProspect ? (
                  <div className="formInputBox textareaFormInputGrid">
                    <label
                      htmlFor="notPTProspectReason"
                      className="formInputLabel"
                    >
                      Reason (Why Not A PT Prospect) (Max 20 -{" "}
                      {formValues.notPTProspectReason?.length || 0}){" "}
                      <span className="required">*</span>
                    </label>

                    <textarea
                      name="notPTProspectReason"
                      className={`formInput 
                      ${formErrors.notPTProspectReason && "formError"}
                    `}
                      placeholder="Enter Reason In Details"
                      value={formValues.notPTProspectReason}
                      onChange={onChangeInput}
                    ></textarea>
                  </div>
                ) : (
                  <>
                    <div className="formInputBox">
                      <label
                        htmlFor="propectPTValue"
                        className="formInputLabel"
                      >
                        prospect Amount <span className="required">*</span>
                      </label>

                      <input
                        type="number"
                        className={`formInput ${
                          formErrors.propectPTValue ? "formError" : ""
                        }`}
                        placeholder="Enter prospect Amount"
                        name="propectPTValue"
                        value={formValues.propectPTValue}
                        onChange={onChangeInput}
                        min={0}
                      />

                      {formErrors.propectPTValue ? (
                        <span className="info">
                          {formErrors.propectPTValue}
                        </span>
                      ) : null}
                    </div>

                    <div className="formInputBox">
                      <label
                        htmlFor="prospectPTExpectedCloserDate"
                        className="formInputLabel"
                      >
                        Prospect Expected closure Date{" "}
                        <span className="required">*</span>
                      </label>

                      <input
                        type="date"
                        className={`formInput ${
                          formValues.prospectPTExpectedCloserDate
                            ? "date-has-value"
                            : ""
                        } ${
                          formErrors.prospectPTExpectedCloserDate
                            ? "formError"
                            : ""
                        }`}
                        placeholder="Enter Expected closure Date"
                        name="prospectPTExpectedCloserDate"
                        value={formValues.prospectPTExpectedCloserDate}
                        onChange={onChangeInput}
                        min={currentMonthCurrentDate}
                      />
                    </div>

                    <div className="formInputBox">
                      <label
                        htmlFor="selProspectSession"
                        className="formInputLabel"
                      >
                        Prospect Session <span className="required">*</span>
                      </label>

                      <div
                        className={`commonWrapper ${
                          formErrors.selProspectSession && "formError"
                        }`}
                      >
                        <SelectDropdown
                          options={
                            sessions?.length > 0
                              ? [
                                  ...sessions,
                                  { label: "Other", value: "other" },
                                ]
                              : [{ label: "Other", value: "other" }]
                          }
                          selectedOption={formValues.selProspectSession}
                          setSelectedOption={(selectedValue) =>
                            onChangeDropdown(
                              "selProspectSession",
                              selectedValue
                            )
                          }
                          name="PT Session"
                          preventKeyboardOpen={true}
                        />
                      </div>
                    </div>

                    {formValues.selProspectSession?.value === "other" ? (
                      <>
                        <div className="formInputBox">
                          <label
                            htmlFor="prospectSession"
                            className="formInputLabel"
                          >
                            prospect session (Other){" "}
                            <span className="required">*</span>
                          </label>

                          <input
                            type="number"
                            className={`formInput ${
                              formErrors.prospectSession ? "formError" : ""
                            }`}
                            placeholder="Enter prospect Session"
                            name="prospectSession"
                            value={formValues.prospectSession}
                            onChange={onChangeInput}
                            min={0}
                          />
                        </div>

                        <div className="formInputBox">
                          <label
                            htmlFor="prospectDuration"
                            className="formInputLabel"
                          >
                            prospect duration (Other){" "}
                            <span className="required">*</span>
                          </label>

                          <input
                            type="number"
                            className={`formInput ${
                              formErrors.prospectDuration ? "formError" : ""
                            }`}
                            placeholder="Enter prospect Duration"
                            name="prospectDuration"
                            value={formValues.prospectDuration}
                            onChange={onChangeInput}
                            min={0}
                          />
                        </div>
                      </>
                    ) : null}
                  </>
                )} */}
              </>

              <div className="formInputBox textareaFormInputGrid">
                <label htmlFor="userMedicalHistory" className="formInputLabel">
                  Any Medical History
                </label>

                <textarea
                  name="userMedicalHistory"
                  className={`formInput ${
                    formErrors.userMedicalHistory && "formError"
                  }`}
                  placeholder="Enter User Medical History If Avaiable"
                  value={formValues.userMedicalHistory}
                  onChange={onChangeInput}></textarea>
              </div>

              <>
                {/* <div
                  className="formInputBox check-input-not-bar"
                  style={{
                    alignItems: "flex-start",
                  }}
                >
                  <Form.Check
                    type="checkbox"
                    name="isPtProspect"
                    className={`${
                      formValues.isPtProspect ? "formError no-border" : ""
                    }`}
                    style={{
                      cursor: "pointer",
                    }}
                    label={`${
                      formValues.isPtProspect
                        ? "Not a PT Prospect"
                        : "Click here if this member is not a prospect"
                    }`}
                    checked={formValues.isPtProspect}
                    onChange={onChangeInput}
                  />
                </div> */}
              </>
            </>
          )}
        </div>

        {!isTrainer && (
          <div className="formInputsGrid fourGridSystem">
            <div className="formInputBox">
              <label htmlFor="selectedSlot" className="formInputLabel">
                Select Slot To Assign Different Trainer
              </label>

              <div
                className={`commonWrapper ${
                  formErrors.selectedSlot && "formError"
                }`}>
                <SelectDropdown
                  options={timeSlots}
                  selectedOption={formValues.selectedSlot}
                  setSelectedOption={(selectedValue) =>
                    onChangeDropdown("selectedSlot", selectedValue)
                  }
                  name="Slot"
                />
              </div>
            </div>

            <div className="formInputBox">
              <label
                htmlFor="selectedTrialCompletedBy"
                className="formInputLabel">
                Assign To Different Trainer
              </label>

              <div
                className={`commonWrapper ${
                  formErrors.selectedTrialCompletedBy && "formError"
                }`}>
                <SelectDropdown
                  options={trainerNamesBySlot}
                  selectedOption={formValues.selectedTrialCompletedBy}
                  setSelectedOption={(selectedValue) =>
                    onChangeDropdown("selectedTrialCompletedBy", selectedValue)
                  }
                  name="Trainer"
                />
              </div>

              {formValues.selectedSlot && trainerNamesBySlot?.length === 0 ? (
                <span className="info">
                  {`No Trainer Availble In The Slot ${
                    formValues.selectedSlot?.label || ""
                  }`}
                </span>
              ) : null}
            </div>

            <>
              {/* <div
                    className="formInputBox formInputSwitchBox"
                    style={{ justifyContent: "flex-end" }}
                  >
                    <div className={`commonWrapper commonSwitchWrapper`}>
                      <Form.Check
                        type="switch"
                        name="isTrialCompletedBySelf"
                        className={`${
                          formErrors?.isTrialCompletedBySelf ? "formError" : ""
                        }`}
                        label={`${
                          formValues.isTrialCompletedBySelf
                            ? "Trial Completed By Me"
                            : "Is Trial Completed By Me ?"
                        }`}
                        checked={formValues.isTrialCompletedBySelf}
                        value={formValues.isTrialCompletedBySelf}
                        onChange={onChangeInput}
                      />
                    </div>
                  </div> */}
            </>
          </div>
        )}

        <div className="grayLine"></div>

        <div className="formInputsGrid threeGridSystem">
          <div className="formInputBox span2">
            <label htmlFor="selectedRunTest" className="formInputLabel">
              <b>1 minute run test</b> (instruction: the client runs in place or
              on a trademill at a consistent pace for 1 minute).
            </label>

            <div
              className={`commonWrapper ${
                formErrors.selectedRunTest && "formError"
              }`}>
              <SelectDropdown
                options={PT_TRIAL_RUN_TEST}
                selectedOption={formValues.selectedRunTest}
                setSelectedOption={(selectedValue) =>
                  onChangeDropdown("selectedRunTest", selectedValue)
                }
                name="Rating"
              />
            </div>
          </div>

          <div className="formInputBox">
            <label htmlFor="selectedPushupTest" className="formInputLabel">
              <b>Push-Up Test</b> (Maximum reps without rest).
            </label>

            <div
              className={`commonWrapper ${
                formErrors.selectedPushupTest && "formError"
              }`}>
              <SelectDropdown
                options={PT_TRIAL_PUSHUP_TEST}
                selectedOption={formValues.selectedPushupTest}
                setSelectedOption={(selectedValue) =>
                  onChangeDropdown("selectedPushupTest", selectedValue)
                }
                name="Repetitions"
              />
            </div>
          </div>

          <div className="formInputBox">
            <label htmlFor="selectedPlankTest" className="formInputLabel">
              <b>Plank Test</b> (Time held in seconds).
            </label>

            <div
              className={`commonWrapper ${
                formErrors.selectedPlankTest && "formError"
              }`}>
              <SelectDropdown
                options={PT_TRIAL_PLANK_TEST}
                selectedOption={formValues.selectedPlankTest}
                setSelectedOption={(selectedValue) =>
                  onChangeDropdown("selectedPlankTest", selectedValue)
                }
                name="Time"
              />
            </div>
          </div>

          <div className="formInputBox">
            <label htmlFor="selectedWallTest" className="formInputLabel">
              <b>Wall Sit Test</b> (Time held in seconds).
            </label>

            <div
              className={`commonWrapper ${
                formErrors.selectedWallTest && "formError"
              }`}>
              <SelectDropdown
                options={PT_TRIAL_PLANK_TEST}
                selectedOption={formValues.selectedWallTest}
                setSelectedOption={(selectedValue) =>
                  onChangeDropdown("selectedWallTest", selectedValue)
                }
                name="Time"
              />
            </div>
          </div>

          <div className="formInputBox">
            <label htmlFor="selectedInlineLungeTest" className="formInputLabel">
              <b>In-Line Lunge Test</b> (Time held in seconds).
            </label>

            <div
              className={`commonWrapper ${
                formErrors.selectedInlineLungeTest && "formError"
              }`}>
              <SelectDropdown
                options={PT_TRIAL_INLINE_LUNGE__TEST}
                selectedOption={formValues.selectedInlineLungeTest}
                setSelectedOption={(selectedValue) =>
                  onChangeDropdown("selectedInlineLungeTest", selectedValue)
                }
                name="Performance"
              />
            </div>
          </div>

          <div className="formInputBox">
            <label
              htmlFor="selectedShoulderFlexionTest"
              className="formInputLabel">
              Shoulder flexion test
            </label>

            <div
              className={`commonWrapper ${
                formErrors.selectedShoulderFlexionTest && "formError"
              }`}>
              <SelectDropdown
                options={PT_TRIAL_SHOULDER_FLEXION_TEST}
                selectedOption={formValues.selectedShoulderFlexionTest}
                setSelectedOption={(selectedValue) =>
                  onChangeDropdown("selectedShoulderFlexionTest", selectedValue)
                }
                name="Performance"
              />
            </div>
          </div>

          <div className="formInputBox">
            <label
              htmlFor="selectedShoulderExtensionTest"
              className="formInputLabel">
              Shoulder extension test
            </label>

            <div
              className={`commonWrapper ${
                formErrors.selectedShoulderExtensionTest && "formError"
              }`}>
              <SelectDropdown
                options={PT_TRIAL_SHOULDER_EXTENSION_TEST}
                selectedOption={formValues.selectedShoulderExtensionTest}
                setSelectedOption={(selectedValue) =>
                  onChangeDropdown(
                    "selectedShoulderExtensionTest",
                    selectedValue
                  )
                }
                name="Performance"
              />
            </div>
          </div>

          <div className="formInputBox">
            <label
              htmlFor="selectedLegRaiseAngleTest"
              className="formInputLabel">
              leg raise angle
            </label>

            <div
              className={`commonWrapper ${
                formErrors.selectedLegRaiseAngleTest && "formError"
              }`}>
              <SelectDropdown
                options={PT_TRIAL_LEG_RAISE_TEST}
                selectedOption={formValues.selectedLegRaiseAngleTest}
                setSelectedOption={(selectedValue) =>
                  onChangeDropdown("selectedLegRaiseAngleTest", selectedValue)
                }
                name="Rating"
              />
            </div>
          </div>

          <div className="formInputBox">
            <label htmlFor="selectedThomasTest" className="formInputLabel">
              <b>thomas test</b> (hip flexor flexibility).
            </label>

            <div
              className={`commonWrapper ${
                formErrors.selectedThomasTest && "formError"
              }`}>
              <SelectDropdown
                options={PT_TRIAL_THOMAS_TEST}
                selectedOption={formValues.selectedThomasTest}
                setSelectedOption={(selectedValue) =>
                  onChangeDropdown("selectedThomasTest", selectedValue)
                }
                name="Performance"
              />
            </div>
          </div>

          <div className="formInputBox">
            <label
              htmlFor="selectedOverallFitnessRating"
              className="formInputLabel">
              overall fitness rating
            </label>

            <div
              className={`commonWrapper ${
                formErrors.selectedOverallFitnessRating && "formError"
              }`}>
              <SelectDropdown
                options={PT_TRIAL_OVERALL_FITNESS_RATING}
                selectedOption={formValues.selectedOverallFitnessRating}
                setSelectedOption={(selectedValue) =>
                  onChangeDropdown(
                    "selectedOverallFitnessRating",
                    selectedValue
                  )
                }
                name="Rating"
              />
            </div>
          </div>
        </div>

        <div className="grayLine"></div>

        {checkPT && userInfo.user_id && (
          <>
            <div className={`commonWrapper commonSwitchWrapper multi-file`}>
              <div className="file-upload multi">
                <>
                  {/* <div
                    className={`input-group file-upload-input ${
                      formErrors?.memberProfileFile ? "formError" : ""
                    }`}
                  >
                    <div className="custom-file">
                      <div className="choosefileBtn">
                        <input
                          type="file"
                          className={`custom-file-input ${
                            formValues.memberProfileFile ? "file-has-value" : ""
                          }`}
                          id="memberProfileFile"
                          name="memberProfileFile"
                          aria-describedby="inputGroupFileAddon01"
                          accept="image/*,.pdf"
                          file={formValues.memberProfileFile}
                          onChange={onChangeInput}
                        />
                      </div>
                      <label
                        className="custom-file-label"
                        htmlFor="memberProfileFile"
                      >
                        Member Profile (Image/PDF)
                      </label>
                      {name === "edit" && rowData?.profile_doc ? (
                        <span className="previous-file">
                          Previous:{" "}
                          <a href={rowData.profile_doc}>
                            {extractFileName(rowData.profile_doc)}
                          </a>
                        </span>
                      ) : null}
                    </div>
                  </div>

                  <div
                    className={`input-group file-upload-input ${
                      formErrors?.memberAssesmentFile ? "formError" : ""
                    }`}
                  >
                    <div className="custom-file">
                      <div className="choosefileBtn">
                        <input
                          type="file"
                          className={`custom-file-input ${
                            formValues.memberAssesmentFile
                              ? "file-has-value"
                              : ""
                          }`}
                          id="memberAssesmentFile"
                          name="memberAssesmentFile"
                          aria-describedby="inputGroupFileAddon01"
                          accept="image/*,.pdf"
                          file={formValues.memberAssesmentFile}
                          onChange={onChangeInput}
                        />
                      </div>
                      <label
                        className="custom-file-label"
                        htmlFor="memberAssesmentFile"
                      >
                        Member Assesment (Image/PDF)
                      </label>
                      {name === "edit" && rowData?.assessment_doc ? (
                        <span className="previous-file">
                          Previous:{" "}
                          <a href={rowData.assessment_doc}>
                            {extractFileName(rowData.assessment_doc)}
                          </a>
                        </span>
                      ) : null}
                    </div>
                  </div>

                  <div
                    className={`input-group file-upload-input ${
                      formErrors?.fitnessCOnsultationFile ? "formError" : ""
                    }`}
                  >
                    <div className="custom-file two-file-selection">
                      <div className="choosefileBtn">
                        <input
                          type="file"
                          className={`custom-file-input fitness-consult1 ${
                            formValues.fitnessCOnsultationFile
                              ? "file-has-value"
                              : ""
                          }`}
                          id="fitnessCOnsultationFile"
                          name="fitnessCOnsultationFile"
                          aria-describedby="inputGroupFileAddon01"
                          accept="image/*,.pdf"
                          file={formValues.fitnessCOnsultationFile}
                          onChange={onChangeInput}
                        />
                      </div>

                      <div
                        className="choosefileBtn"
                        style={{ marginTop: "15px" }}
                      >
                        <input
                          type="file"
                          className={`custom-file-input ${
                            formValues.fitnessCOnsultationFile1
                              ? "file-has-value"
                              : ""
                          }`}
                          id="fitnessCOnsultationFile1"
                          name="fitnessCOnsultationFile1"
                          aria-describedby="inputGroupFileAddon01"
                          accept="image/*,.pdf"
                          title="Upload Fitness Consult Second Page"
                          file={formValues.fitnessCOnsultationFile1}
                          onChange={onChangeInput}
                        />
                      </div>

                      <label
                        className="custom-file-label"
                        htmlFor="fitnessCOnsultationFile"
                        style={{ marginTop: "10px" }}
                      >
                        Fitness Consultation (Page 1 and page 2 | Image/PDF)
                      </label>

                      {name === "edit" && rowData?.ftns_cnsltnt_doc1 ? (
                        <span
                          className="previous-file"
                          style={{ marginTop: "10px" }}
                        >
                          Previous (First Page):{" "}
                          <a href={rowData.ftns_cnsltnt_doc1}>
                            {extractFileName(rowData.ftns_cnsltnt_doc1)}
                          </a>
                        </span>
                      ) : null}

                      {name === "edit" && rowData?.ftns_cnsltnt_doc2 ? (
                        <span
                          className="previous-file"
                          style={{ marginTop: "10px" }}
                        >
                          Previous (Second Page):{" "}
                          <a href={rowData.ftns_cnsltnt_doc2}>
                            {" "}
                            {extractFileName(rowData.ftns_cnsltnt_doc2)}
                          </a>
                        </span>
                      ) : null}
                    </div>
                  </div> */}
                </>

                <div
                  className={`input-group file-upload-input ${
                    formErrors?.bcaFile ? "formError" : ""
                  }`}>
                  <div className="custom-file">
                    <div className="choosefileBtn">
                      <input
                        type="file"
                        className={`custom-file-input ${
                          formValues.bcaFile ? "file-has-value" : ""
                        }`}
                        id="bcaFile"
                        name="bcaFile"
                        aria-describedby="inputGroupFileAddon01"
                        accept="application/pdf"
                        file={formValues.bcaFile}
                        onChange={onChangeInput}
                      />
                    </div>
                    <label className="custom-file-label" htmlFor="bcaFile">
                      BCA Report (PDF Only) <span className="required">*</span>
                    </label>
                    {name === "edit" && rowData?.bca_report ? (
                      <span className="previous-file">
                        Previous:{" "}
                        <a href={rowData.bca_report}>
                          {extractFileName(rowData.bca_report)}
                        </a>
                      </span>
                    ) : null}
                  </div>
                </div>
              </div>

              <Form.Check
                type="switch"
                name="isActive"
                className={`${formErrors?.isActive ? "formError" : ""}`}
                label={`${formValues.isActive ? "Active" : "Inactive For Now"}`}
                checked={formValues.isActive}
                onChange={onChangeInput}
              />
              <Form.Check
                type="switch"
                name="isInformationCorrect"
                className={`${
                  formErrors?.isInformationCorrect ? "formError no-border" : ""
                }`}
                label={`${
                  formValues.isInformationCorrect
                    ? "All Information Is Correct"
                    : "Is All Information Correct?"
                }`}
                checked={formValues.isInformationCorrect}
                onChange={onChangeInput}
              />
            </div>

            {loading ? (
              <ReactVortoxSpinner />
            ) : (
              <div
                className="formButtons"
                style={{ justifyContent: "flex-end" }}>
                {isShowBackBtn && (
                  <Button
                    className="saveBtn"
                    variant="outline-danger"
                    onClick={handleBack}>
                    Back
                  </Button>
                )}
                <Button className="saveBtn" variant="danger" onClick={onSubmit}>
                  {name === "edit" ? "Update" : "Submit"}
                </Button>
              </div>
            )}
          </>
        )}
      </form>
    </div>
  );
};

export default PTTrialForm;
